
export function mapProject(project) {
  project.images = {
    preview: project.images?.large?.url
  };

  return project;
}
